module.exports = __webpack_public_path__ + "img/ending.a6cb8141.svg";